import { i18n } from "@lingui/core";
import { messages } from "../locales/en/messages";

export function activateI18n(locale: "en") {
  i18n.loadAndActivate({ locale, messages });
}
